import Vue from 'vue';

export const projectsListService = {
  async getProjects(sortOrder, paginationParameters, searchParam) {
    return Vue.axios
      .get('/projects', {
        params: {
          ...sortOrder,
          ...paginationParameters,
          searchParam
        }
      })
      .then(response => response.data);
  },
  async getFilteredRecordCount(searchParam) {
    return Vue.axios
      .get('/projects/projects-count', {
        params: { searchParam }
      })
      .then(response => response.data);
  }
};
